import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { resetPersonaSessionContext } from '../lib/persona-session-reset.js'
import { hasFreshSessionQuery } from '../lib/visitor-session-isolation.js'

/**
 * When /chat?fresh= or /chat?new=1 is present, wipe stale persona context once on mount.
 * Smokes and manual QA use this to avoid cross-run identity bleed.
 */
export function useFreshSessionReset(): void {
  const [searchParams, setSearchParams] = useSearchParams()
  const handledRef = useRef(false)

  useEffect(() => {
    if (handledRef.current) return
    if (!hasFreshSessionQuery(`?${searchParams.toString()}`)) return
    handledRef.current = true
    resetPersonaSessionContext()
    const next = new URLSearchParams(searchParams)
    next.delete('fresh')
    next.delete('new')
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams])
}
